import React, { memo } from "react";
import { getDefaultComponentStyle } from "./utils/defaultStyles";

export default memo(({ data }: { data: IMultiElementCombineMsg.ILineElem }) => {
  const { color } = data;
  const style = getDefaultComponentStyle(data) as any;

  let lineStyle: IMultiElementCombineMsg.ILineStyle = {};
  color && (lineStyle.backgroundColor = `#${color}`);

  // return <div className={"sscard-lineBox"} style={style}></div>;
  return (
    <div className="sscard-lineBox" style={style}>
      <div className="line" style={lineStyle}></div>
    </div>
  );
});
